//福瑞达
import Overview from './overview.vue';
import MobFull from '@/rebuild/materials/shared/quote/mobile/SlideMobFull.vue';

export const componentMap = {
    overview: Overview,
    'mob-full': MobFull
}; 